import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use(Navigation);
Swiper.use(Pagination);

/**
 * Extends options for swiper to add support for General Slider Nav
 * @param {Object} el - HTML element that contains the nav
*/
export const addGenericSwiperNav = el => {
  const prevEl = el._$('.slider-nav__arrow--prev');
  const nextEl = el._$('.slider-nav__arrow--next');
  const $pager = el._$('.slider-nav__pager');
  const renderCustom = (_, current, total) => `${current} / ${total}`;

  return {
    pagination: {
      type: 'custom',
      el: $pager,
      modifierClass: '',
      renderCustom
    },
    navigation: {
      disabledClass: 'slider-nav__arrow--disabled',
      prevEl,
      nextEl
    }
  }
}
